export default __webpack_public_path__ + "static/media/slider-right-icon.4364dfb4.svg";